import { render } from "./ReviewLetter.vue?vue&type=template&id=cbd65410&scoped=true&ts=true"
import script from "./ReviewLetter.vue?vue&type=script&lang=ts"
export * from "./ReviewLetter.vue?vue&type=script&lang=ts"

import "./ReviewLetter.vue?vue&type=style&index=0&id=cbd65410&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd65410"]])

export default __exports__